export default "__VITE_ASSET__BERitcDd__"